import React, { useEffect, useState,useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import JobDetailsFormContainer from './JobDetailsFormContainer';
import { getCategoryDisplayName } from 'util/JobTypeHelper';
import Logger from 'util/Logger';
//import * as HistoryHelper from 'util/HistoryHelper';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle,
} from 'components/layout';
import { validateJob } from 'util/JobValidationUtils';
import TreatementTypeIds from 'constants/TreatmentTypeIds';
//import { useNavigate } from 'react-router-dom';
//import { formValues } from 'redux-form';

const JobDetailsCreatePage = ({ actions, initialValues, jobType, isCreditAllowed,navigate,formValues }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stopCredit, setStopCredit] = useState(false);
 // const navigateTo = useNavigate();

  useEffect(() => {
    if(isCreditAllowed!=undefined){
      actions.clearClientDetails();
      actions.clearTreatmentType();
    }
  }, [actions,formValues]); //empty array ensures useEffect will only run once 

  const handleSubmit=(formValues)=>{
  }

  const createJob = (formValues) => {
    toggleFormSubmit();
    actions.createNewJob(formValues).then((data) => {
      toggleFormSubmit();
      Logger.success('New Job Created');

      if (
        formValues.newNoticeOfIntendedTreatment &&
        formValues.newNoticeOfIntendedTreatment.sendNotice &&
        formValues.treatmentDetails.treatmentTypeId !== TreatementTypeIds.WaterBlasting &&
        formValues.technicianId !== null
      ) {
        Logger.success('Notice of Intended Treatment sent');
      }
      actions.getJobLocations();
      navigate('/');
      return data;
    });
  };

  const toggleFormSubmit = () => {
    setIsSubmitting((prev) => !prev);
  };

  const cancelJob = () => {
    //HistoryHelper.performSafeGoBack();
    navigate('/dashboard')
  };

  const getPageHeaderLabel = (jobType) => {
    const jobCategory = getCategoryDisplayName(jobType.category);
    return `New ${jobType.name} ${jobCategory} job sheet`;
  };
  const updatedInitialValues = {
    ...initialValues,
    customerCompleted: false,
    stopCredit: false
  };
/*
  initialValues.customerCompleted = false;

  if (isCreditAllowed === 'false') {
    initialValues.stopCredit = true;
  }*/

  if (!jobType) {
    return null;
  }

  return (
    <div>
      <Header>
        <HeaderButtonNav>
          <HeaderButton
          title={"Cancel"}
            color="primary"
            onClick={cancelJob}
            ligature="clear"
          />
        </HeaderButtonNav>
        <HeaderTitle
          label={getPageHeaderLabel(jobType)}
          imageUrl={jobType.imageUrlFull}
        />
      </Header>
      <JobDetailsFormContainer
        onSubmit={(formValues)=>validateJob(formValues, createJob)}
        isSubmitting={isSubmitting}
        initialValues={updatedInitialValues}
        jobType={jobType}
        formValues={formValues}
      />
    </div>
  );
};

JobDetailsCreatePage.propTypes = {
  actions: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  jobType: PropTypes.object.isRequired,
  isCreditAllowed: PropTypes.string,
};

export default JobDetailsCreatePage;
